import SearchBar from '@app/components/SearchBar'
import { ICurrentUserState } from '@app/store/modules/account'
import { IGlobalSocialNetworksState } from '@app/store/modules/global'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { actionCreators, IConnectionViewState } from '../modules/connectionView'

interface IConnectionViewRouterProps {
  id: string
}

interface IComponentState {
  filterText: string
}

type IComponentProps = IConnectionViewState &
  ICurrentUserState &
  IGlobalSocialNetworksState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators

class ConnectionProperties extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      filterText: '',
    }
  }

  public render() {
    return <div>{this._renderProperties()}</div>
  }

  private _renderProperties() {
    if (!this.props.item.properties || this.props.item.properties.size === 0) {
      return 'No Properties'
    }

    const filteredProperties = this.props.item.properties.filter(
      (item: any) => {
        return this.state.filterText
          ? item.name
              .toLowerCase()
              .indexOf(this.state.filterText.toLowerCase()) > -1 ||
              item.address.line1
                .toLowerCase()
                .indexOf(this.state.filterText.toLowerCase()) > -1 ||
              item.address.city
                .toLowerCase()
                .indexOf(this.state.filterText.toLowerCase()) > -1 ||
              item.address.state
                .toLowerCase()
                .indexOf(this.state.filterText.toLowerCase()) > -1 ||
              item.address.zip
                .toLowerCase()
                .indexOf(this.state.filterText.toLowerCase()) > -1
          : true
      },
    )

    const properties = filteredProperties.map((property: any) => {
      return (
        <div key={property.propertyId} className='my-2'>
          <a
            className='d-flex flex-row'
            target='_blank'
            rel='noreferrer'
            style={{ color: 'black' }}
            href={`/properties/property/${property.propertyId}`}
          >
            <img
              height='100'
              width='150'
              src={`/api/Properties/${property.propertyId}/ThumbnailImage?h=100&w=150`}
            />
            <div className='ml-2 align-self-center'>
              <div>
                <strong>{property.name}</strong>
              </div>
              <div>{formatAddressSingleLine(property.address)}</div>
            </div>
          </a>
        </div>
      )
    })

    return (
      <div>
        <SearchBar
          placeholder='Filter properties...'
          size='sm'
          value={this.state.filterText}
          onChange={(e) => {
            this.setState({
              filterText: e,
            })
          }}
        />
        {properties}
      </div>
    )
  }
}

export default withRouter(ConnectionProperties)
